import _ from 'lodash';
import {getDefaultPieFormatting} from '../../charts/pie';
import {HighChartHandler} from '../../resources/config-schema';
import {IBaselineSubmissionProps, IFinaleSubmissionProps} from '../resources/Submission';

const transform = [
    {
        name: 'Full-time contracts',
        value: 'totalCountFullTimeContracts',
        color: '#5b9bd5',
    },
    {
        name: 'Part-time contracts',
        value: 'totalCountFixTermContracts',
        color: '#ed7d32',
    },
];

/**
 * == baseline
 * question28_row_1_column_1 - Full-time contracts
 * question28_row_2_column_1 - Part-time contracts
 *
 * == final
 * question85_row_1_column_1 - Full-time contracts
 * question85_row_2_column_1 - Part-time contracts
 *
 * @param baselineSubmissions
 * @param finalSubmissions
 * @param title
 * @returns
 */
export const newJobsTypeContractChartCalculation: HighChartHandler<IBaselineSubmissionProps, IFinaleSubmissionProps> =
    (baselineSubmissions, finalSubmissions, title) => {
        const calculateDifferences = (baselineField: string, finalField: string) => {
            const baselineValue = baselineSubmissions.reduce(function (a, b: any) {
                return a + (Number(b[baselineField]) || 0);
            }, 0);
            const finalValue =  finalSubmissions.reduce(function (a, b: any) {
                return a + (Number(b[finalField]) || 0);
            }, 0);

            return finalValue - baselineValue;
        };

        const totalCountFullTimeContracts = calculateDifferences('question28_row_1_column_1', 'question85_row_1_column_1');
        const totalCountPartTimeContracts = calculateDifferences('question28_row_2_column_1', 'question85_row_2_column_1');
        
        const data = transform.map((el) => ({
            name: el.name,
            color: el.color,
            y: el.value === 'totalCountFullTimeContracts' ? totalCountFullTimeContracts : totalCountPartTimeContracts,
        }));
        
        return getDefaultPieFormatting(title || null, data) as Highcharts.Options;
    }